module.exports = __webpack_public_path__ + "img/label.1c577c0b.png";